/**
 * 원산지 — 서버 `server/src/domain/origin.ts` 의 사본이다. 한쪽을 고치면 다른 쪽도 고칠 것.
 *
 * 품목 마스터에서 셋 중 하나를 고른다. 저장·전송은 코드로만 하고(인보이스에 그대로 찍힌다)
 * 표기는 언어 사전(`origin.*`)이 정한다.
 */

export const ORIGIN_COUNTRIES = ["KOREA", "CHINA", "JAPAN"] as const
export type OriginCountry = (typeof ORIGIN_COUNTRIES)[number]

/** 품목을 새로 만들 때 미리 골라 두는 원산지. 대부분 한국산이다. */
export const DEFAULT_ORIGIN: OriginCountry = "KOREA"

export function isOriginCountry(value: string): value is OriginCountry {
  return (ORIGIN_COUNTRIES as readonly string[]).includes(value)
}

/** 모르는 값(인보이스 줄에 손으로 적은 옛 원산지)은 번역하지 않고 그대로 보여 준다. */
export function originLabel(origin: string | null, t: (key: string) => string): string | null {
  if (origin === null || origin === "") return null
  return isOriginCountry(origin) ? t(`origin.${origin}`) : origin
}
